export default [{
	path: 'course',
	component: () => import('../../views/platform/meCourse/course'),
	redirect: '/home/course/simexp',
	children: [{
			path: 'resource',
			component: () => import('../../views/platform/resource')
		},
		{
			path: 'simexp',
			component: () => import('../../views/platform/webgl')
		}, {
			path: 'practice',
			component: () => import('../../views/platform/practice')
		},
		{
			path: 'unittesting',
			component: () => import('../../views/platform/unittesting')
		},
		{
			path: 'exam',
			component: () => import('../../views/platform/exam')
		},
		{
			path: 'questionbank',
			component: () => import('../../views/platform/questionBanks')
		}
	]
}]